import { Component, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BackendService } from '@core/services';
import { ButtonComponent } from '@shared/components/button/button.component';
import {
  InputComponent,
  TextAreaComponent,
} from '@shared/components/form-fields';
import { ContactFormSecondVariantConfig } from '@shared/models';

import { ContactFormBase } from '../contact-form-base.class';

@Component({
  selector: 'b2c-variant2',
  styleUrl: './variant2.component.scss',
  templateUrl: './variant2.component.html',
  imports: [
    FormsModule,
    InputComponent,
    ButtonComponent,
    TextAreaComponent,
    ReactiveFormsModule,
  ],
})
export class Variant2Component extends ContactFormBase implements OnInit {
  config = input.required<ContactFormSecondVariantConfig>();

  public backendService: BackendService = inject(BackendService);

  ngOnInit(): void {
    this._contactForm = this.createForm(this.config().contactFormBlock.fields);
  }

  submit(): void {
    if (this.submitted() || this.form.invalid) {
      return;
    }

    this.submitted.set(true);

    const { email, content } = this._contactForm.value;

    this.backendService
      .sendClaim(content, this.backendService.untienotsId, '', email)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.form.reset();
        this.submitted.set(false);
      });
  }
}
